import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITalonInfo } from '../interfaces/record.interfaces';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import { IDocAboutInfo } from '../interfaces/doctor.interfaces';

@Injectable({
    providedIn: 'root',
})
export class DoctorService {
    public constructor(private httpNew: HttpNewService, private auth: AuthService) {}

    /* Информация о враче */
    public getDocAboutInfo(doctorId: number): Observable<Array<IDocAboutInfo>> {
        let url = '/doctor/info';
        if (doctorId) {
            url = url + `?doctorId=${doctorId}`;
        }
        return this.httpNew.get<Array<IDocAboutInfo>>(url, null);
    }
}
